module.exports = __webpack_public_path__ + "img/logo.5b55a5f8.svg";